import React from 'react';

import { proxy } from 'valtio';

const ContextMenuService = {
    state: proxy({
        x: null as number | null,
        y: null as number | null,
    }),

    content: null as React.ReactNode | null,

    open: (x: number, y: number, content: React.ReactNode) => {
        ContextMenuService.state.x = x;
        ContextMenuService.state.y = y;
        ContextMenuService.content = content;
    },

    close: () => {
        ContextMenuService.state.x = null;
        ContextMenuService.state.y = null;
        ContextMenuService.content = null;
    },
};

export { ContextMenuService };
